import { render, staticRenderFns } from "./CardRegistrationView.vue?vue&type=template&id=4f62f43a&scoped=true"
import script from "./CardRegistrationView.vue?vue&type=script&lang=js"
export * from "./CardRegistrationView.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrationView.vue?vue&type=style&index=0&id=4f62f43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62f43a",
  null
  
)

export default component.exports